import { render, staticRenderFns } from "./Other.vue?vue&type=template&id=38297c6e&scoped=true&"
import script from "./Other.vue?vue&type=script&lang=js&"
export * from "./Other.vue?vue&type=script&lang=js&"
import style0 from "../../../../../src/assets/css/shop-console.css?vue&type=style&index=0&id=38297c6e&scoped=true&lang=css&"
import style1 from "./Other.vue?vue&type=style&index=1&id=38297c6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38297c6e",
  null
  
)

export default component.exports